/** 输入框类型 */
export const INPUT_TYPE = {
  /** 账号 */
  ACCOUNT:        0,
  /** 手机号 */
  PHONE:          1,
  /** 邮箱 */
  EMAIL:          2,
  /** 获取短信验证码 */
  GET_SMS_CODE:   3,
  /** 获取邮箱验证码 */
  GET_EMAIL_CODE: 4,
  /** 密码 */
  PASSWORD:       5,
  /** 再一次输入密码 */
  AGAIN_PASSWORD: 6,
  /** 图形验证码 */
  IMG_VERIFY:     7
}

/** 页面类型 */
export const PAGE_TYPE = {
  /** 更密周期页面 */
  DenserPeriod:   'denserPeriod',
  /** 忘记密码页面 */
  ForgotPassword: 'forgotPassword'
}

/** 登陆类型 */
export const LOGIN_TYPE = {
  ACCOUNT: 1,
  EMAIL:   2,
  PHONE:   3
}

/** 输入框图标 */
export const INPUT_ICON = {
  [INPUT_TYPE.ACCOUNT]:        'LiveCloud-addressBook-user1',
  [INPUT_TYPE.PHONE]:          'LiveCloud-common-shouji',
  [INPUT_TYPE.EMAIL]:          'LiveCloud-common-weidu',
  [INPUT_TYPE.GET_SMS_CODE]:   'LiveCloud-yycd-menudubanlixiang',
  [INPUT_TYPE.GET_EMAIL_CODE]: 'LiveCloud-yycd-menudubanlixiang',
  [INPUT_TYPE.PASSWORD]:       'LiveCloud-common-mima',
  [INPUT_TYPE.AGAIN_PASSWORD]: 'LiveCloud-common-mima'
}

/**二维码返回状态 */
export const QR_CODE_STATUS = {
  /** 二维码新建 */
  NEW:      'BUILD',
  /**二维码等待确认 */
  CONFIRM:  'CONFIRM',
  /** 二维码已确认 */
  COMPLETE: 'COMPLETE',
  /** 二维码取消 */
  CANCEL:   'CANCEL',
  /** 二维码失败 */
  FAIL:     'FAIL',
  /** 二维码过期 */
  EXPIRE:   'EXPIRE'

}